import React, { useCallback } from 'react';
import clsx from 'clsx';
import { TypedMemo } from '../../common/types';
import { Breadcrumb } from './types';

interface SMLBreadcrumbProps {
  breadcrumb: Breadcrumb;
  isLast: boolean;
}

const SMLBreadcrumbComponent: React.FC<React.PropsWithChildren<SMLBreadcrumbProps>> = ({ breadcrumb, isLast }) => {
  const { name, onClick } = breadcrumb;

  const handleClick: React.MouseEventHandler<HTMLAnchorElement> = useCallback(
    (event) => {
      event.preventDefault();
      onClick?.();
    },
    [onClick]
  );

  return (
    <span className={clsx({ 'fw-light opacity-5': !isLast })}>
      {onClick !== undefined ? (
        <a href="/#" onClick={handleClick} className="text-body text-decoration-none">
          {name}
        </a>
      ) : (
        <span className="text-body">{name}</span>
      )}
      {isLast ? '' : ' / '}
    </span>
  );
};

export const SMLBreadcrumb = TypedMemo(SMLBreadcrumbComponent);
